/* import __COLOCATED_TEMPLATE__ from './revision.hbs'; */
import Component from "@glimmer/component";
import { service } from "@ember/service";
import TEMPLATE from "./revision.hbs";
import { setComponentTemplate } from "@ember/component";
export default class Revision extends Component {
  static #_ = (() => dt7948.g(this.prototype, "site", [service]))();
  #site = (() => (dt7948.i(this, "site"), void 0))();
}
setComponentTemplate(TEMPLATE, Revision);